import React from "react";
import Title from "../../ui/Title";

const StrongCare = () => {
  return (
    <div id="strong-care-economy" className="scroll-mt-24">
      <Title title="What does a strong care economy need?" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal mt-4">
        <p>
          The ILO has formulated a ‘5R Framework for Decent Care Work’, a{" "}
          <a
            href="https://www.ilo.org/sites/default/files/wcmsp5/groups/public/%40dgreports/%40dcomm/%40publ/documents/publication/wcms_633135.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            policy framework
          </a>{" "}
          designed to ensure that care policies are human rights-based and
          gender-responsive by addressing the issues that prevent women from
          engaging in paid work, and improving the conditions of carers who are
          unpaid.
        </p>
        <p>
          According to the 5R framework (Recognize, Reduce, Redistribute,
          Reward, Represent) unpaid care work should be recognized, reduced, and
          redistributed, while paid care work should be rewarded and care
          workers should be represented.
        </p>
        <div className="flex flex-col items-center justify-center">
          <img src="/assets/img/5RFramework.png" alt="5R Framework" />
          <p className="text-xs text-softBlack font-normal">
            Source: Care Work and Care Jobs for the Future of Decent Work;
            Chapter 6 , (
            <a
              href="https://www.ilo.org/sites/default/files/wcmsp5/groups/public/%40dgreports/%40dcomm/%40publ/documents/publication/wcms_633135.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              ILO publication
            </a>
            ){" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StrongCare;
